module.exports = __webpack_public_path__ + "media/images/human-resources-2f51ed8f.png";